import {useTranslation} from 'react-i18next';
import {TMemberSubscription} from '../memberTicket.type';
import * as css from './MemberTicketInfo.css';

interface MemberTicketInfoProps {
    subscription: TMemberSubscription;
}

type InfoField = {
    key: string;
    label: string;
    value?: string | number;
    numeric?: boolean;
};

/* The member's details: customer name, how many subscriptions, the price it was sold on and the ticket number.
   The number is the ticket's own (qid) and not the order's — an order holding two series would
   otherwise print the same number on both cards; the order number belongs to the transaction screen.
   Each row holds one or two fields — a field with no value is dropped and its row shrinks with it. */
function MemberTicketInfo({subscription}: MemberTicketInfoProps) {
    const {t} = useTranslation('eTicket');

    const rows: InfoField[][] = [
        [{key: 'customer', label: t('customerName'), value: subscription.customerName}],
        [
            {key: 'amount', label: t('subscriptionsAmount'), value: subscription.subscribersCount, numeric: true},
            {key: 'priceTitle', label: t('subscriptionPriceTitle'), value: subscription.priceTitle}
        ],
        [{key: 'ticketNumber', label: t('ticketNumber'), value: subscription.qid, numeric: true}]
    ]
        .map(fields => fields.filter(({value}) => value !== undefined && value !== null && value !== ''))
        .filter(fields => fields.length);

    return (
        <css.info data-cy="member-ticket-info">
            {rows.map(fields => (
                <css.row key={fields[0].key}>
                    {fields.map(({key, label, value, numeric}) => (
                        <css.field key={key}>
                            <css.label>{label}</css.label>
                            <css.value $numeric={numeric} data-cy={`member-ticket-${key}`}>
                                {value}
                            </css.value>
                        </css.field>
                    ))}
                </css.row>
            ))}
        </css.info>
    );
}

export default MemberTicketInfo;
